var windowWidth=$(window).width();
(function(){
    resize_windows();
    $(window).resize(function(){
      $('#header .toggle_bar').removeClass('active')
        if(windowWidth!=$(window).width()){
          resize_windows()
          windowWidth=$(window).width()
        }
    });

function resize_windows(){
  if($(window).width() <= 1200){
    $('#header .menu_list').hide();
    $('#header .menu_list .menu_list_bottom>li').off('mouseenter');
    $('#header .menu_list .menu_list_bottom>li').off('mouseleave');
    $('#header .menu_list .menu_list_bottom>li>span').click(function(event){
      var event = event || window.event;
      event.stopPropagation() ? event.stopPropagation() : event.cancelBubble = true
      if($(this).parent('li').hasClass('active')){
        $(this).parent('li').removeClass('active')
        $(this).parent('li').find('.drop_list_box').hide()
      }else{
        $(this).parent('li').addClass('active').siblings().removeClass('active');
        $(this).parent('li').find('.drop_list_box').show()
      }
      $(this).parent('li').siblings().find('.drop_list_box').hide();
    });
  }else{
    $('#header .menu_list').css({'display':"block"});
    $('#header .menu_list .menu_list_bottom li span').on('mouseenter',debounce(function(){
      $(this).parent('li').addClass('active').siblings().removeClass('active');
      $(this).parent('li').find('.drop_list_box').show();
      $(this).parent('li').siblings().find('.drop_list_box').hide();
    },100))
    $('#header .menu_list .menu_list_bottom li').on('mouseleave',function(){
      $(this).removeClass('active');
      $(this).find('.drop_list_box').hide();
      $(this).siblings().find('.drop_list_box').hide();
    });
  }
}

if($(window).width() <= 1200){
  $('.footer dl dt').click(function(){
    $(this).parent('dl').toggleClass('active');
  })
}
$('#header .toggle_bar').click(function(event){
  var event = window.event || event;
  event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
    if($('.menu_list').css('display')=='block'){
      $('.header_bg').removeClass('active');
    }else{
      $('.header_bg').addClass('active');
    }
    $('.menu_list').slideToggle();
    $(this).toggleClass('active')
})
// footer
$('#footer .language_box').click(function(event){
  var event = window.event || event;
  event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
    $('#footer .language_list').slideToggle()
    $('#footer .language_box').toggleClass('active');
    if(event.target.nodeName.toLowerCase() == 'li'){
      var now_language = event.target.getAttribute('data-value');
      doGTranslate(now_language);
    }
});
$(document).click(function(){
    if($(window).width()<1200){
    $('.menu_list').hide();
    $('.header_bg').removeClass('active');
    $('#header .toggle_bar').removeClass('active');
    $('#footer .language_box').removeClass('active');
    try {
      $('.recommend_topbox').hide();
    } catch (error) {
      
    }
    }
    $('.language_list').hide();
    $('#footer .language_box').removeClass('active');
})
if($(window).width() <= 1200){
  $('#footer .footer_list .footer_item').click(function(event){
    var event = window.event || event;
    event.stopPropagation ? event.stopPropagation() : event.cancelBubble = true;
      $(this).find('.footer_item>ul').slideToggle();
      $(this).toggleClass('active');
  })
}

// 订阅
const subscribeBtn = $('.footer .subscribe_btn');
const subscribeBox = $('.subscribe_box');
const subscribeFormBox = $('.subscribe_box .form_box');
const subscribeSuccessBox = $('.subscribe_box .success_box');
const reg_subscribe_email = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const reg_subscribe_phone = /^[+()\d\s-]{6,20}$/;
const reg_subscribe_zip = /^[A-Za-z0-9\s-]{3,12}$/;

let subscribeErrorTimer = null;

function resetSubscribeForm(){
    if(!subscribeFormBox.length) return;
    if (subscribeErrorTimer) {
        clearTimeout(subscribeErrorTimer);
        subscribeErrorTimer = null;
    }
    subscribeFormBox.find('input').val('');
    subscribeFormBox.find('.item').removeClass('error');
    subscribeFormBox.find('.item > div > p').hide();
}

// 1. 点击 footer 订阅按钮 - 弹窗出现
if (subscribeBtn.length && subscribeBox.length) {
    subscribeBtn.on('click', function(){
        subscribeBox.css({'display':'flex'});
        if (subscribeFormBox.length) subscribeFormBox.show();
        if (subscribeSuccessBox.length) subscribeSuccessBox.hide();
        resetSubscribeForm();
    });
}

// 2. 点击关闭按钮 / 取消按钮 - 弹窗关闭
if (subscribeBox.length) {
    subscribeBox.on('click', '.close, .btn_cancel', function(){
        subscribeBox.hide();
        resetSubscribeForm();
    });
}

// 3. 表单提交
$('.subscribe_box .btn_submit').on('click', function(){
    if (!subscribeFormBox.length) return;

    const $form = subscribeFormBox;

    const firstName = $('#name').val().trim();
    const lastName = $('#lastname').val().trim();
    const email = $('#email').val().trim();
    const country = $('#country').val().trim();
    const phone = $('#phone').val().trim();
    const zipCode = $('#code').val().trim();

    // 重置错误
    $form.find('.item').removeClass('error');
    $form.find('.item > div > p').hide();

    let hasError = false;

    if (!firstName) {
        $('.name_item').addClass('error').children('div').children('p').show();
        hasError = true;
    }
    if (!lastName) {
      $('.lastname_item').addClass('error').children('div').children('p').show();
        hasError = true;
    }
    if (!email) {
        $('.email_item').addClass('error').find('.em_empty').show();
        hasError = true;
    } else if (!reg_subscribe_email.test(email)) {
        $('.email_item').addClass('error').find('.em_error').show();
        hasError = true;
    }
    if (!country) {
      $('.country_item').addClass('error').find('.em_empty').show();
        hasError = true;
    }
    if (phone && !reg_subscribe_phone.test(phone)) {
      $('.phone_item').addClass('error').find('.em_error').show();
        hasError = true;
    }
    if (zipCode && !reg_subscribe_zip.test(zipCode)) {
      $('.code_item').addClass('error').find('.em_error').show();
        hasError = true;
    }

    if (hasError) {
        if (subscribeErrorTimer) clearTimeout(subscribeErrorTimer);
        subscribeErrorTimer = setTimeout(function(){
            $form.find('.item').removeClass('error');
            $form.find('.item > div > p').hide();
            subscribeErrorTimer = null;
        }, 3000);
        return;
    }

    // 4. 提交成功后显示 success_box
    $.ajax({
        url: 'https://www.topvox.ai/api/subscribe-v1.php',
        method: 'post',
        dataType: 'json',
        data: {
            'first_name': firstName,
            'last_name': lastName,
            'email': email,
            'country': country,
            'phone': phone,
            'zip_code': zipCode,
            'source': '1',
        },
        success: function(res){
            subscribeFormBox.hide();
            if (subscribeSuccessBox.length) {
                subscribeSuccessBox.show();
            }
            $form.find('input').val('');
        },
        error: function(jqXHR, textStatus, errorThrown) {
            console.error('error:', textStatus, errorThrown);
            alert('Subscription failed. Please try again later.');
        }
    });
});

// 关闭
const formSuccessClose = $('.form_success>div .close');
if (formSuccessClose.length) {
    formSuccessClose.click(function(){
        const formSuccess = $('.form_success');
        if (formSuccess.length) {
            formSuccess.hide()
        }
    })
}

// 防抖
function debounce(fn,speed){
  var timer = null;
  return function(){
    var that  = this;
    var arg = arguments;
    setTimeout(timer);
    if(!timer){
        setTimeout(function(){fn.apply(that,arg)},speed)
    }
  }
};
})(windowWidth);


//gotop
(function(){
  $('body').append('<i class="gotop"></i>');
  $(window).scroll(function(){
      if($(document).scrollTop()>=400){
          $('.gotop').show();
          $('.gotop').click(function(){
              $("body,html").scrollTop(0);
          })
      }else{$('.gotop').hide();};
  });
})();

(function(){
//系统识别
function system_confirm(){var userAgentInfo = navigator.userAgent;if(userAgentInfo.indexOf("Win")>-1){return "win"}else if(userAgentInfo.indexOf("Mac")>-1){return "mac"}};function device_confirm(){var userAgentInfo = navigator.userAgent;var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];var flag = true;for (var v = 0; v < Agents.length; v++) {if (userAgentInfo.indexOf(Agents[v]) > 0) {flag = false;break;}}return flag;};
if(system_confirm()=="mac"&&device_confirm()){var isMac=true}
else if(system_confirm()=="win"&&device_confirm()){var isMac=false}
if(device_confirm()==true){var device_id=true}
else if(device_confirm()==false){var device_id=false}else{};
function system_fn(){
    if (isMac == true) {
        $('.mac_btn').addClass('active').siblings('.win_btn').removeClass('active');
        $('.sys_mac').addClass('active').siblings('.sys_win').removeClass('active');
    } else if (!isMac == true) {
        $('.sys_win').addClass('active').siblings('.mac_btn').removeClass('active');
        $('.win_btn').addClass('active').siblings('.sys_mac').removeClass('active');
    } else if (device_id == false) {
        $('.pc_btn').css({"display":"none"});
        $('.mac_inline').css({"display":"none"});
        $('.win_inline').css({"display":"inline-block"});
    };
};
system_fn();
})();


// 促销
$(document).ready(function() {
  let isAnimated = false;
  let lastScrollTop = 0;
  function handleSpecialBoxAnimation() {
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();
      const specialBox = $('.special_box');
  
      if (scrollTop > windowHeight && scrollTop > lastScrollTop) {
          if (!isAnimated) {
              specialBox.removeClass('reverse').addClass('animate');
              isAnimated = true;
          }
      } 
      else if (scrollTop <= windowHeight && scrollTop < lastScrollTop) {
          if (isAnimated) {
              specialBox.removeClass('animate').addClass('reverse');
              isAnimated = false;
          }
      }
      lastScrollTop = scrollTop;
  }
  
  function initSpecialBox() {
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();
      const specialBox = $('.special_box');
      
      if (scrollTop > windowHeight) {
          specialBox.addClass('animate');
          isAnimated = true;
      } else {
          specialBox.removeClass('animate reverse');
          isAnimated = false;
      }
  }
  $('.special_box .close').click(function(e) {
      $('.special_box').hide();
  })
  $(window).on('scroll', handleSpecialBoxAnimation);
  initSpecialBox();
  $(window).on('resize', function() {
      initSpecialBox();
  });
});


// 打点
window.manage=function(operation,data){
  try{
      dataLayer.push({
          'event':'dotting',
          'name':'www',
          'operation':operation,
          'lable':String(data)
      })
  }catch(e){
      console.log(e);
  }
};